import React, {useEffect} from "react";
import {Col, Container, Row} from "react-bs4grid";
import useAppState from "../../common/StateMachine/useAppState";

import JobCard from "./JobCard";

import "./jobs.scss";

const BrowseNew = () => {
    const jobsState = useAppState("jobs");

    useEffect(() => {
        jobsState.getJobs(null, false, null);
    }, []);

    return (
        <Container fluid className="jobs-list-container">
            <Row
                className="jobs-list pt-24 pb-64"
                justifyContent="center"
                alignItems="center"
                style={{flexDirection: "column"}}
            >
                {jobsState.state.jobs.data &&
                jobsState.state.jobs.data
                    .sort((a, b) => {
                        return new Date(b.dueByLocal) - new Date(a.dueByLocal);
                    })
                    .map(job => {
                        return (
                            <Col
                                className="job-column"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                                key={job.id}
                                sm={{
                                    size: 12
                                }}
                                md={{
                                    size: 8
                                }}
                            >
                                <JobCard id={job.id} {...job} />
                            </Col>
                        );
                    })}
            </Row>
        </Container>
    );
};

export default BrowseNew;
